import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentMethodCode } from '../models/payment-method-code.enum';

export class PaymentForm extends FormGroup {
  constructor(
    method: PaymentMethodCode = null,
    creditCardId: string = null,
    phoneNumber: string = null,
    verificationCode: string = null,
  ) {
    super({
      creditCard: new FormControl(creditCardId),
      method: new FormControl(method),
      phoneNumber: new FormControl(phoneNumber, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]),
      verificationCode: new FormControl(verificationCode),
    });
  }

  get method(): FormControl {
    return this.get('method') as FormControl;
  }

  get creditCard(): FormControl {
    return this.get('creditCard') as FormControl;
  }

  get phoneNumber(): FormControl {
    return this.get('phoneNumber') as FormControl;
  }

  get verificationCode(): FormControl {
    return this.get('verificationCode') as FormControl;
  }

  get methodSelected(): boolean {
    return this.method.value !== null;
  }
}
